import { Loader2, TriangleAlert } from 'lucide-react'
import { Alert, AlertDescription } from '@/components/ui/alert'
import type { Copy, ServiceError } from '@/frontend/pages/Dashboard/Workflows/types'

export default function BlockState({ loading, error, copy }: { loading?: boolean; error?: ServiceError | null; copy: Copy }) {
  if (error) return <Alert variant="destructive"><TriangleAlert aria-hidden /><AlertDescription>{error.message}</AlertDescription></Alert>
  if (loading) return <p role="status" className="flex items-center gap-2 py-4 text-sm text-muted-foreground"><Loader2 className="size-4 animate-spin" aria-hidden />{copy.shared.loading}</p>
  return null
}
